import React from "react"
import Newsletter from "./newsletter"

const MNewsletter = (props) => {
  const onSuccess = () => {
    window.location.href = process.env.NEWSLETTER_SUCCESS_URL
  }

  return (
    <Newsletter
      data={{
        ...props.data,
        baseClass: "m-Newsletter",
        darkTheme: true,
        defaultPadding: "extra-large",
      }}
      onSuccess={onSuccess}
    />
  )
}

export default MNewsletter
